import Glide from "@glidejs/glide";
import Heading from "components/Heading/Heading";
import React, { FC } from "react";
import { useEffect } from "react";
import clientSayMain from "images/clientSayMain.png";
import clientSay1 from "images/clientSay1.png";
import clientSay2 from "images/clientSay2.png";
import clientSay3 from "images/clientSay3.png";
import clientSay4 from "images/clientSay4.png";
import clientSay5 from "images/clientSay5.png";
import clientSay6 from "images/clientSay6.png";
import quotationImg from "images/quotation.png";
import quotationImg2 from "images/quotation2.png";
import useNcId from "hooks/useNcId";


const googleReviewLink = process.env.REACT_APP_LINKREVIEWGOOGLE;

export interface SectionClientSayProps {
  className?: string;
  uniqueClassName: string;
}

const DEMO_DATA = [
  {
    id: 1,
    clientName: "Nazario Magnani",
    clientAddress: "Roma (RM), Lazio",
    content:
    "Abbiamo soggiornato già due volte dagli amici Emanuela e Sergio lo scorso anno. Sono accoglienti, disponibili e tanto altro. Così per completare il soggiorno in alloggi confortevoli e con una posizione spettacolare (tra il santuario ed il sito archeologico) con vista spettacolare su tutta la costa tirrenica e le isole Eolie. Rapporto qualità prezzo eccellente. Ci torneremo anche il prossimo settembre. Grazie di cuore 💓",
  },
  {
    id: 2,
    clientName: "Giulia Rossi",
    clientAddress: "Patti (ME), Sicily",
    content:
    "Soggiorno splendido in una oasi di pace. Il luogo è dotato di tutti i servizi. Emanuela è stata accogliente e premurosa. Gli appartamenti sono immersi nel verde degli ulivi con spazi comuni incantevoli.",
  },
  {
    id: 3,
    clientName: "Massimo La Mancusa",
    clientAddress: "Patti (ME), Sicily",
    content:
      "Luogo incantevole, posto molto confortevole, dove trascorrere anche un lungo soggiorno, sentendosi come a casa propria. Padrona di casa accogliente, gentile e disponibile. Consigliatissimo .",
  },
  {
    id: 4,
    clientName: "Monica Di Blanco Pontillo",
    clientAddress: "Firenze (FI), Toscana",
    content:
      "Location tranquilla con un panorama dove il mare e le isole Eolie fanno da cornice.Gli appartamenti sono ben arredati e muniti di tutte le comodità per poter soggiornare in piena libertà.A pochi passi da Villa Greco troverete la piazza del Santuario di Tindari e il teatro greco. L’host Emanuela,simpatica e affabile.Consiglio il soggiorno,per poter vivere un’esperienza dove la tranquillità ed il relax faranno da padroni",
  },
  {
    id: 6,
    clientName: "Danilo Desi",
    clientAddress: "Verona (VR), Veneto",
    content:
      "Bellissima villa di campagna situata accanto allo splendido Parco Archeologico di Tindari e a 100 MT dal Bellissimo Santuario della Madonna di Tindari. La casa ha un ampio spazio esterno dove si può ammirare un panorama da lasciare senza fiato. All'esterno nel giardino i proprietari mettono a disposizione barbecue e carbonella per arrostire...Se tornerò in questi luoghi soggiornerò sicuramente da loro.",
  },
];

const SectionClientSay: FC<SectionClientSayProps> = ({
  className = "",
  uniqueClassName = "",
}) => {
  const UNIQUE_CLASS = `SectionClientSay_glide_${uniqueClassName}` + useNcId();

  useEffect(() => {
    if (document.querySelector(`.${UNIQUE_CLASS}`)) {
      setTimeout(() => {
        new Glide(`.${UNIQUE_CLASS}`, {
          perView: 1,
        }).mount();
      }, 10);
    }
  }, []);

  const renderBg = () => {
    return (
      <div className="hidden md:block">
        <img className="absolute top-9 -left-20" src={clientSay1} alt="" />
        <img
          className="absolute bottom-[100px] right-full mr-40"
          src={clientSay2}
          alt=""
        />
        <img
          className="absolute top-full left-[140px]"
          src={clientSay3}
          alt=""
        />
        <img
          className="absolute -bottom-10 right-[140px]"
          src={clientSay4}
          alt=""
        />
        <img
          className="absolute left-full ml-32 bottom-[80px]"
          src={clientSay5}
          alt=""
        />
        <img className="absolute -right-10 top-10 " src={clientSay6} alt="" />
      </div>
    );
  };

  return (
    <div
      className={`nc-SectionClientSay relative ${className} `}
      data-nc-id="SectionClientSay"
    >
     <a
  href={googleReviewLink}
  target="_blank"
  rel="noopener noreferrer"
  className="flex flex-col items-center justify-center space-y-2 bg-white shadow-lg hover:shadow-xl rounded-lg p-4 text-blue-500 hover:text-white hover:bg-gradient-to-r from-blue-500 to-green-500 transition-all duration-300 transform hover:scale-105"
  data-tip="Leggi le recensioni su Google"
>
  <div className="flex items-center space-x-2">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="32px" height="32px">
      <path fill="#4285F4" d="M24 9.5c3.1 0 5.2 1.3 6.4 2.4l4.7-4.7C32.2 4.6 28.6 3 24 3 14.6 3 7 10.6 7 20s7.6 17 17 17c4.6 0 8.2-1.6 11-4.2l-4.7-4.7c-1.2 1.1-3.3 2.4-6.3 2.4-5.6 0-10.1-4.5-10.1-10.1S18.4 9.5 24 9.5z"/>
      <path fill="#34A853" d="M46.5 24c0-1.5-.1-2.6-.3-3.8H24v7.2h12.7c-.5 2.6-2.1 4.8-4.4 6.3l4.7 4.7c2.7-2.5 4.5-6.2 4.5-10.4z"/>
      <path fill="#FBBC05" d="M24 46.5c6.3 0 11.6-2.1 15.5-5.7l-4.7-4.7c-2.1 1.4-4.8 2.4-7.8 2.4-6 0-11.1-4.1-12.9-9.6H7v6.1C10.9 41.1 17 46.5 24 46.5z"/>
      <path fill="#EA4335" d="M11.1 28.9c-1.1-2.6-1.1-5.4 0-8l-6.1-6.1C2.5 17.6 1 20.7 1 24s1.5 6.4 4 8.9l6.1-6.1z"/>
    </svg>
    <h3 className="text-lg font-semibold">Cosa dicono di noi</h3>
  </div>
  <p className="text-center text-sm text-gray-600">
    Scopri cosa dicono i nostri clienti sul loro soggiorno anche su Google
  </p>
</a>
      <div className="relative md:mb-16 max-w-2xl mx-auto mt-5">
        {renderBg()}
        <img className="mx-auto" src={clientSayMain} alt="" />
        <div className={`mt-12 lg:mt-16 relative ${UNIQUE_CLASS}`}>
          <img
            className="opacity-50 md:opacity-100 absolute -mr-16 lg:mr-3 right-full top-1"
            src={quotationImg}
            alt=""
          />
          <img
            className="opacity-50 md:opacity-100 absolute -ml-16 lg:ml-3 left-full top-1"
            src={quotationImg2}
            alt=""
          />
          <div className="glide__track " data-glide-el="track">
            <ul className="glide__slides ">
              {DEMO_DATA.map((item) => (
                <li
                  key={item.id}
                  className="glide__slide flex flex-col items-center text-center"
                >
                  <span className="block mt-8 text-2xl font-semibold">
                    {item.clientName}
                  </span>
                  <br />
                  <span className="block text-2xl">{item.content}</span>
                  {/* disattivati per ora cosi non si vede la location delle recenzioni */}
                  {/* <div className="flex items-center space-x-2 text-lg mt-2 text-neutral-400">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-6 w-6"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={1.5}
                        d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                      />
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={1.5}
                        d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                      />
                    </svg>
                    <span>{item.clientAddress}</span>
                  </div> */}
                </li>
              ))}
            </ul>
          </div>
          <div
            className="mt-10 glide__bullets flex items-center justify-center"
            data-glide-el="controls[nav]"
          >
            {DEMO_DATA.map((item, index) => (
              <button
                key={item.id}
                className="glide__bullet w-2 h-2 rounded-full bg-neutral-300 mx-1 focus:outline-none"
                data-glide-dir={`=${index}`}
              ></button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SectionClientSay;
